/* eslint-disable */

export const works = [
  {
    id: "adsfasdfasdfasdfas",
    name: "Obra induc",
    client: "Mónica Gómes",
    province: "Guayas",
    city: "Guayaquil",
    address: "Calle larga y calle corta",
    administrativeAddress: "Av. Victo Emilio Estrada",
    // coordinates: "lng: -2.1040544, lat: -79.9373055",
    zipCode: "4364865",
    phone: "26465465",
    description: ""
  },
];
